import { APITypesV1 } from "@cur8/api-client";
import { isUS } from "lib/market";

// Both pre-printed labels belong to the same member, so swapping them between
// the two tubes passes every identity check on the screen. Naming the tube by
// its cap colour makes the operator confirm which tube the label went on.
//
// US only: colours are confirmed there and nowhere else yet, so other markets
// name no colour. Wrong colour guidance would be worse than none on a step
// meant to catch a mis-applied label.
const US_CAP_COLOURS: Record<APITypesV1.SampleType, string> = {
  [APITypesV1.SampleType.Plasma]: "green",
  [APITypesV1.SampleType.WholeBlood]: "purple",
};

export function tubeCapColour(
  sampleType: APITypesV1.SampleType,
  countryCode: string | undefined
): string | undefined {
  if (!isUS(countryCode)) {
    return undefined;
  }
  return US_CAP_COLOURS[sampleType];
}
